import { LayoutGrid } from "lucide-react";

/** The framing used by every signed-out screen: login, first-run setup, invites. */
export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-dvh app-surface flex items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <div className="w-14 h-14 rounded-2xl bg-white/10 border border-white/20 backdrop-blur-sm flex items-center justify-center mb-4">
            <LayoutGrid className="w-7 h-7 text-white" />
          </div>
          <h1 className="text-xl font-semibold text-white">{title}</h1>
          {subtitle && <p className="text-white/50 text-sm mt-1 text-center">{subtitle}</p>}
        </div>

        <div className="bg-white/5 border border-white/10 rounded-2xl p-6 backdrop-blur-sm">{children}</div>

        {footer && <div className="mt-4 text-center text-white/40 text-xs">{footer}</div>}
      </div>
    </div>
  );
}

export function AuthField({ label, hint, children }) {
  return (
    <label className="block">
      <span className="text-white/70 text-sm font-medium">{label}</span>
      {children}
      {hint && <span className="block text-white/35 text-xs mt-1">{hint}</span>}
    </label>
  );
}

export const authInputClass =
  "mt-1 w-full bg-white/10 border border-white/20 rounded-xl px-3 py-2 text-white " +
  "placeholder-white/30 focus:outline-none focus:ring-2 focus:ring-white/30 text-sm";
